import React, { FC, ReactElement, useState } from 'react'
import { useCookies } from 'react-cookie'
import FitbitReconnectBanner from './layout/FitbitReconnectBanner'
import useLegacyFitbitIntegration from './hooks/useLegacyFitbitIntegration'
import integrationStartUrl from './integrationStartUrl'
import {
  FITBIT_RECONNECT_DISMISSED_COOKIE as DISMISSED_COOKIE,
  FITBIT_RECONNECT_DISMISSED_MAX_AGE as DISMISSED_MAX_AGE
} from 'components/common/Constants'

// The same warning as the one on the integrations overview, but shown on every
// page so users with a legacy Fitbit connection see it without opening the
// "Add data" modal first. Dismissable, since it is shown platform wide.
const GlobalFitbitReconnectBanner: FC = (): ReactElement => {
  const [cookies, setCookie] = useCookies([DISMISSED_COOKIE])
  const [dismissed, setDismissed] = useState(false)
  const hidden = dismissed || Boolean(cookies[DISMISSED_COOKIE])
  // Asking svc for the registrations is pointless once the user hid the
  // warning, so the query only runs while the banner can still show.
  const { hasLegacyFitbit, reconnectUrl } = useLegacyFitbitIntegration(!hidden)

  const dismiss = (): void => {
    setCookie(DISMISSED_COOKIE, true, { path: '/', maxAge: DISMISSED_MAX_AGE })
    setDismissed(true)
  }

  const reconnect = (): void => {
    if (reconnectUrl === undefined) return
    window.location.href = integrationStartUrl(reconnectUrl)
  }

  if (hidden) return <></>
  if (!hasLegacyFitbit || reconnectUrl === undefined) return <></>

  return (
    <div className='container'>
      <FitbitReconnectBanner
        onReconnect={reconnect}
        onDismiss={dismiss}
        className='fitbit-reconnect-banner--global'
        testId='global-fitbit-reconnect-banner'
      />
    </div>
  )
}

export default GlobalFitbitReconnectBanner
